/* eslint-disable max-nested-callbacks */
import apiFactory from "@/helpers/api";

const {
	get: surveyAPIGet,
	post: surveyAPIPost,
} = apiFactory();

export const fetchSurveyTemplate = async ( options = { templateId: "0000000-0000-0000-0000-000000000000", } ) => {
	const { templateId, } = options;
	return surveyAPIGet( `/surveytemplate/${templateId}` );
};

export const createNewTeamHealthSurvey = async ( { teamId, newSurveyEmailMessage, } ) => {
	return surveyAPIPost( "/survey", { teamId, newSurveyEmailMessage, } );
};

export const fetchTeamSurveys = async ( { teamId, } ) => {
	return surveyAPIGet( "/survey", { teamId, } );
};

export const saveSurveyResponse = async ( { surveyInstanceId, data, } ) => {
	return surveyAPIPost( `/survey/${ surveyInstanceId }/response`, { data, } );
};

export const publishSurveyResults = async ( { surveyInstanceId, } ) => {
	return surveyAPIPost( `/survey/${ surveyInstanceId }/publishedsurvey` );
};



// WEBPACK FOOTER //
// ./src/api/surveyAPI.js